import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API } from "../../API";
import { isAutheticated, signout } from "../auth/authhelper";

export default function Header() {
  const [data, setData] = useState({
    name: "",
    email: "",
    picture: "",
  });

  const { token, type } = isAutheticated();

  useEffect(() => {
    axios
      .get(`${API}/api/user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const userdata = response.data.data;
        console.log("userdata", userdata)
        setData({
          name: userdata.name,
          lastName: userdata.email,
          picture: userdata?.picture,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [token]);

  const renderUserInitials = () => {
    return `${data.name ? data.name.charAt(0) : ""}`;
  };

  return (
    <header id="page-topbar">
      <div className="navbar-header">
        <div className="d-flex justify-content-between w-100">
          {/* Logo */}
          <div className="navbar-brand-box">
            <a href="index.html" className="logo logo-dark">
              <span className="logo-sm">
                <img src="assets/images/logo-sm.png" alt="Logo" height="50" />
              </span>
              <span className="logo-lg">
                <img src="assets/images/logo-dark.png" alt="Logo" height="20" />
              </span>
            </a>
          </div>

          {/* Hamburger Button for Mobile */}
          <button
            type="button"
            className="btn btn-sm font-size-16 header-item waves-effect vertical-menu-btn d-lg-none navbar-toggler"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="fa fa-fw fa-bars"></i>
          </button>

          {/* Navbar Menu for Large Screens */}
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ml-auto">
              {/* Add menu items here */}
            </ul>
          </div>

          {/* User Profile Dropdown - Top Right Corner */}
          <div className="dropdown d-inline-block ml-auto">
            <button
              type="button"
              className="btn header-item waves-effect"
              id="page-header-user-dropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div className="d-flex align-items-center">
                {/* Profile Picture or Initials */}
                {data.picture ? (
                  <img
                    className="rounded-circle header-profile-user"
                    src={data.picture}
                    alt="User Avatar"
                    height="30"
                  />
                ) : (
                  <div className="avatar-xs">
                    <span className="avatar-title bg-primary rounded-circle font-size-16">
                      {renderUserInitials()}
                    </span>
                  </div>
                )}
                <span className="ml-2 d-none d-xl-inline-block">
                  {data.name
                    ? `${data.name} `
                    : "User"}
                </span>
                <i className="uil-angle-down font-size-15 ml-1 d-none d-xl-inline-block"></i>
              </div>
            </button>

            <div className="dropdown-menu dropdown-menu-right">
              {/* <Link className="dropdown-item" to="/profile">
                <i className="fa fa-user mr-2"></i> Profile
              </Link> */}
              {(type === "admin" || type === "staff") && (
                <Link className="dropdown-item" to="/change/password">
                  <i className="fa fa-cogs mr-2"></i> Change Password
                </Link>
              )}
              <div className="dropdown-divider"></div>
              <span onClick={signout}>
                <Link className="dropdown-item" to="/">
                  <i className="fa fa-sign-out-alt mr-2"></i> Sign out
                </Link>
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
